<template>
  <div class="grey lighten-4 pa-4" style="min-height: 100vh;">
    <v-container>
      <v-card>
        <v-toolbar flat color="indigo darken-1" dark>
          <v-toolbar-title>
            <v-icon left>mdi-store</v-icon>
            Ecommerce
          </v-toolbar-title>
        </v-toolbar>

        <!-- PC: Tabs con flechas -->
        <v-tabs v-if="$vuetify.breakpoint.mdAndUp" v-model="tab" show-arrows
          background-color="indigo lighten-5">
          <v-tab v-for="item in sections" :key="item.key" :href="'#' + item.key">
            <v-icon left small>{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-tab>
        </v-tabs>

        <!-- Mobile: Select -->
        <div v-else class="pa-3">
          <v-select v-model="tab" :items="sections" item-text="text" item-value="key"
            outlined dense hide-details prepend-inner-icon="mdi-menu">
          </v-select>
        </div>

        <!-- Contenido del tab -->
        <v-tabs-items v-model="tab">
          <v-tab-item value="mi-vendedor">
            <mi-vendedor></mi-vendedor>
          </v-tab-item>
          <v-tab-item value="categoria">
            <categoria-comp></categoria-comp>
          </v-tab-item>
          <v-tab-item value="proveedor">
            <proveedor-comp></proveedor-comp>
          </v-tab-item>
          <v-tab-item value="producto">
            <producto-comp></producto-comp>
          </v-tab-item>
          <v-tab-item value="compras">
            <compra-comp></compra-comp>
          </v-tab-item>
          <v-tab-item value="ventas">
            <venta-comp></venta-comp>
          </v-tab-item>
          <v-tab-item value="pedidos">
            <pedido-comp></pedido-comp>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'EcommerceHubV',
  components: {
    MiVendedor: () => import(/* webpackChunkName: "ecommerce" */ '@/components/tienda/vendedor/MiVendedor.vue'),
    CategoriaComp: () => import(/* webpackChunkName: "ecommerce" */ '@/views/tienda/CategoriaV.vue'),
    ProveedorComp: () => import(/* webpackChunkName: "ecommerce" */ '@/views/tienda/ProveedorV.vue'),
    ProductoComp: () => import(/* webpackChunkName: "ecommerce" */ '@/views/tienda/ProductoV.vue'),
    CompraComp: () => import(/* webpackChunkName: "ecommerce" */ '@/views/tienda/CompraV.vue'),
    VentaComp: () => import(/* webpackChunkName: "ecommerce" */ '@/views/tienda/VentaV.vue'),
    PedidoComp: () => import(/* webpackChunkName: "ecommerce" */ '@/views/tienda/PedidoV.vue'),
  },
  data() {
    return {
      tab: 'mi-vendedor',
      sections: [
        { key: 'mi-vendedor', text: 'Mi Vendedor', icon: 'mdi-account-tie' },
        { key: 'categoria', text: 'Categoría', icon: 'mdi-tag' },
        { key: 'proveedor', text: 'Proveedor', icon: 'mdi-truck' },
        { key: 'producto', text: 'Producto', icon: 'mdi-package-variant' },
        { key: 'compras', text: 'Compras', icon: 'mdi-cart-arrow-down' },
        { key: 'ventas', text: 'Ventas', icon: 'mdi-cart-outline' },
        { key: 'pedidos', text: 'Pedidos', icon: 'mdi-clipboard-list' },
      ]
    };
  }
};
</script>
